import { getUserInfoFromCache } from "utility/helper";

const BASE_URL = process.env.REACT_APP_OPEN_API_URL ?? "";

/** Values allowed on the generated API `lang` header. */
export type HeyApiLangHeader = "sv" | "no" | "da" | "all";

export function normalizeHeyApiLang(locale: string | null | undefined): HeyApiLangHeader | undefined {
  if (locale === "sv" || locale === "no" || locale === "da" || locale === "all") {
    return locale;
  }
  return undefined;
}

/**
 * Shared config for @hey-api/client-fetch SDK functions (`getApiProducts`, etc.).
 * Spread into the request options. Do not pass a custom `client` — the generator
 * spreads options into fetch, and `client` breaks that.
 *
 * @see https://heyapi.dev/openapi-ts/clients/fetch
 */
export function getHeyApiRequestOptions(lang?: HeyApiLangHeader) {
  return {
    baseUrl: BASE_URL,
    auth: () => {
      const token = getUserInfoFromCache()?.token;
      return token ? `Bearer ${token}` : undefined;
    },
    ...(lang ? { headers: { lang } } : {}),
  };
}
